
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ModalEmailService } from "../../../../common/modal-email/modal-email.service";
import {Router, ActivatedRoute} from "@angular/router";

@Component({
  selector: 'service-cleaner',
  templateUrl: '../../templates/partials/cleaner-service.html'
})
export class CleanerServiceComponent{

    @Input() cleaner;
    @Output() assignEmitter = new EventEmitter();
    @Input() canceled;
    @Input() openAssign;

    constructor(private modalEmailService: ModalEmailService, private router: Router){}

    public assignCleaner(){
        this.openAssign = true;
        this.assignEmitter.emit("assign");
    }

    public unassignCleaner(){
        this.assignEmitter.emit("unassign");
    }

    public showModalEmail(email: string){
        this.modalEmailService.openModalEmail(email);
    }

    public goToCleaner(id: string) {
        this.router.navigate(["/cleaners",id]);
    }

    public closeAssign() {
        this.openAssign = false;
        this.assignEmitter.emit("close");
    }

}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/dummy/cleaner-service.component.ts